export default "__VITE_ASSET__DJETi6qw__"